import * as Bixby from './../../core';
import { AppState } from './..';
import {
  FORGOT_PASSWORD_REQUEST_INPROGRESS,
  FORGOT_PASSWORD_REQUEST_FAILURE,
  FORGOT_PASSWORD_REQUEST_SUCCESS,
} from './types';
import { FORGOT_PASSWORD_EMAIL_REQUIRED, FORGOT_PASSWORD_SENT_MESSAGE } from '$/core/constants';
import { ThunkAction } from 'redux-thunk';
import { UserClientService } from '$/services';

export const forgotPasswordRequestInProgress = () => {
  return {
    type: FORGOT_PASSWORD_REQUEST_INPROGRESS,
  };
};

export const forgotPasswordRequestFailure = (error: Bixby.Models.BixbyError) => {
  return {
    type: FORGOT_PASSWORD_REQUEST_FAILURE,
    payload: error,
    error: true,
    success: false,
  };
};

export const forgotPasswordRequestSuccess = (successMessage: string) => {
  return {
    type: FORGOT_PASSWORD_REQUEST_SUCCESS,
    payload: successMessage,
    success: true,
  };
};

// thunk actions
const handleForgotPasswordError =
  (error: Bixby.Models.BixbyError): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(forgotPasswordRequestFailure(error));
  };

const handleForgotPasswordSuccess =
  (successMessage: string): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(forgotPasswordRequestSuccess(successMessage));
  };

export const forgotPasswordRequest = (
  forgotPasswordRequest: Bixby.Models.ForgotPasswordRequest
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    dispatch(forgotPasswordRequestInProgress());
    if (Bixby.Utils.isNullOrEmpty(forgotPasswordRequest.email)) {
      dispatch(handleForgotPasswordError(new Error(FORGOT_PASSWORD_EMAIL_REQUIRED)));
    } else {
      try {
        await UserClientService.forgotPassword(forgotPasswordRequest);
        dispatch(handleForgotPasswordSuccess(FORGOT_PASSWORD_SENT_MESSAGE));
      } catch (error: any) {
        dispatch(handleForgotPasswordError(error));
      }
    }
  };
};
